var InputFactory = require('./input-factory');

var Row = Class.extend( {
    init: function( rowId, prof, $tab, $prev, grid, zContext ) {
        this.id = rowId;
        this.prof = prof;
        this.grid = grid;
        this.inputs = {};
        this.linkageMap = {};
        this.$tab = $tab;
        if ($prev) {
            this.$tr = $('<tr>').insertAfter($prev);
        } else {
            this.$tr = $('<tr>').appendTo(this.$tab);
        }
        this.$tr.attr('id', rowId);
        if (prof.hoverHighlight) {
            this.$tr.hover(function(e) {
                $(this).find('td').addClass('ui-state-hover');
            }, function(e) {
                $(this).find('td').removeClass('ui-state-hover');
            });
        }
        var that = this;

        if (prof.showRowIndex) {
            this.$tr.append('<td class="ui-state-default index">'
             + (this.$tr.index() + 1) + '</td>');
        }

        // that.__bindSourceData(function(sourceData) {

        for ( var i in prof.colModel ) {
            var model = prof.colModel[ i ];
            model.row = that;
            var $td = $('<td>').addClass('ui-widget-content')
                .css('text-align', model.textAlign || 'center')
                .appendTo(that.$tr);

            // Create input instances.
            that.inputs[ model.name.toUpperCase() ] = InputFactory.create(
                model.type,
                model,
                $td,
                zContext
            );

            // Create input linkage map.
            // var params = model.source ? model.source.params : [];
            // if ( model.bindValue ) {
            //     params.push( model.bindValue );
            // }
            // for ( var i = 0; i < params.length; i++ ) {
            //     if ( new RegExp( '^' + wno + '-' ).test( params[i] ) ) {
            //         var motivation = (params[i].split('-')[1]).toUpperCase();
            //         var linkList = that.linkageMap[motivation] || [];
            //         linkList.push( model.name );
            //         that.linkageMap[ motivation ] = linkList;
            //     }
            // }
        }
        var isComplete = {};

        for ( var i in that.inputs ) {
            isComplete[i] = false;
        }
        function isAllComplete() {
            for ( var i in isComplete ) {
                if ( !isComplete[i] ) {
                    return false;
                }
            }
            return true;
        }
        // Call initData sperated from input creation.
        for ( var i in that.inputs ) {
            ( function(k) {
                that.inputs[k].initData( zContext, function() {
                    isComplete[k] = true;
                    // Trigger form complete event, when all input data is ready.
                    if ( isAllComplete() ) {
                        that.grid.trigRowEvent( 'rowComplete', that );
                    }
                } );
            } )(i);
        }
    },
    // __bindSourceData: function( callback ) {
    //     var that = this;
    //     if (that.prof.source) {
    //         that.getSourceData( that.prof.source.id, {
    //             format: 'default'
    //         }, function( data ) {
    //             var sourceData = data[0];
    //             if (sourceData) {
    //                 for (var i in sourceData) {
    //                     sourceData[i.toLowerCase()] = sourceData[i];
    //                 }
    //             }
    //             that.sourceData = sourceData;
    //             callback( that.sourceData );
    //         } );
    //         return;
    //     }
    //     callback();
    // },
    getFieldSourceData: function( fieldName ) {
        return this.sourceData
            ? this.sourceData[fieldName.toLowerCase()]
            : undefined;
    },
    getId: function() {
        return this.id;
    },
    getData: function() {
        var data = {};
        var inp;
        for ( var i in this.inputs ) {
            inp = this.inputs[ i ];
            if (!inp) {
                console.error( 'No input instance for ' + i );
                continue;
            }
            data[ i ] = inp.getTypedValue();
            if ( typeof inp.getDisplayName === 'function' ) {
                data[ i + '_DISPLAY_NAME' ] = inp.getDisplayName();
            }
        }
        return data;
    },
    setData: function(data) {
        data = data || {};
        for ( var i in data ) {
            var input = this.inputs[i.toUpperCase()];
            if (input) {
                input.setValue(data[i]);
            }
        }
    },
    getId: function() {
        return this.id;
    },
    isReady: function() {
        var isReady = true;
        for (var i in this.inputs) {
            if (!this.inputs[i].check()) {
                isReady = false;
            }
        }
        return isReady;
    },
    
    affected: function( zContext ) {
        var that = this;
        // var source = that.prof.source;

        // // If source data needs to be refresh, rebind source data
        // // and then affect each input to refresh value.
        // if (source) {
        //     that.__bindSourceData( function() {
        //         var inp;
        //         for ( i in that.inputs  ) {
        //             inp = that.inputs[ i ];
        //             inp.affected( zContext );
        //         }
        //     } );
        //     return;
        // }
        // // Else affect each input directly.
        debugger;
        var inp;
        for ( i in that.inputs  ) {
            inp = that.inputs[ i ];
            inp.affected( zContext );
        }
    },
    linkage: function( inputName ) {
        console.log('linkage is not implemented.');
        // var zContext = this.getZContext(); // <--  defined by super class.
        // zContext.merge( this.context() );
        // this.setZContext( zContext );
        // var linkList = this.linkageMap[ inputName.toUpperCase() ] || [];
        // var input;
        // for ( var i = 0; i < linkList.length; i++ ) {
        //     input = this.getInput(linkList[i]);
        //     if (input) {
        //         input.affected( zContext );
        //     }
        // }
    },
    destroy: function() {
        this.$tr.remove();
    },
    getInput: function( name ) {
        return this.inputs[ name.toUpperCase() ];
    },
    setLastFocusInputName: function( name ) {
        this.lastFocusInputName = name;
    },
    getLastFocusInputName: function() {
        return this.lastFocusInputName || null;
    },
    getLastFocusInputValue: function() {
        if (this.lastFocusInputName) {
            var inp = this.getInput(this.lastFocusInputName);
            if (inp) {
                return inp.getTypedValue();
            }
        }
        return null;
    },
    getLastEventInput: function() {
        return this.lastEventInput;
    },
    trigInputEvent: function( eventName, srcInput ) {
        this.lastEventInput = srcInput;
        this.grid.trigRowEvent( srcInput.getName() + 'On' + eventName, this );
        if (eventName === 'Change' || eventName === 'Check') {
            this.grid.trigRowEvent( 'rowChange', this );
        }
    },
    getWindowNo: function() {
        return this.grid.getWindowNo();
    },
    getGrid: function() {
        return this.grid;
    }
} );

module.exports = Row;



/*****************
 ** WEBPACK FOOTER
 ** ./src/row.js
 ** module id = 7
 ** module chunks = 0
 **/